/**
 * 选择状态管理 Hook
 */
import { useState, type Dispatch, type SetStateAction } from "react";
import { RoleNode } from "../config/types";
import { Admin } from "../config/types";

export interface UseSelectionStateReturn {
  selectedRole: RoleNode | null;
  selectedAdmin: Admin | null;
  hasUnsavedChanges: boolean;
  activeTab: string;
  setSelectedRole: Dispatch<SetStateAction<RoleNode | null>>;
  setSelectedAdmin: Dispatch<SetStateAction<Admin | null>>;
  setHasUnsavedChanges: Dispatch<SetStateAction<boolean>>;
  setActiveTab: Dispatch<SetStateAction<string>>;
}

/**
 * 选择状态管理 Hook
 */
export const useSelectionState = (): UseSelectionStateReturn => {
  const [selectedRole, setSelectedRole] = useState<RoleNode | null>(null);
  const [selectedAdmin, setSelectedAdmin] = useState<Admin | null>(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<string>("roles");

  return {
    selectedRole,
    selectedAdmin,
    hasUnsavedChanges,
    activeTab,
    setSelectedRole,
    setSelectedAdmin,
    setHasUnsavedChanges,
    setActiveTab,
  };
};

